import React from 'react';

import { ActivityCell } from 'components/common/Tables/Cells/ActivityCell/ActivityCell';
import { ActivityIdCell } from 'components/common/Tables/Cells/ActivityIdCell/ActivityIdCell';
import { RelationTypeCell } from 'components/common/Tables/Cells/RelationTypeCell/RelationTypeCell';
import { TooltipCell } from 'components/common/Tables/Cells/TooltipCell/TooltipCell';
import { DefaultColumnFilter } from 'components/common/Tables/components/ColumnFilter/ColumnFilter';

import classes from 'components/widgets/CrossProgramRelationships/CrossProgramRelationships.module.scss';

export const initialState = {
    sortBy: [
        {
            id: 'predecessor.originalProjectId',
        },
    ],
};

export const defaultColumn = {
    Filter: DefaultColumnFilter,
};

export const columns = [
    {
        Header: () => <div className={classes.header}>Predecessor</div>,
        meta: {
            columnLabel: 'Predecessor',
        },
        id: 'Predecessor',
        columns: [
            {
                Header: 'Version ID',
                accessor: 'predecessor.originalProjectId',
                width: 120,
                fixedSize: true,
            },
            {
                Header: 'Version Name',
                accessor: 'predecessor.originalProjectName',
                Cell: ({ value }) => {
                    return <TooltipCell value={value} />;
                },
            },
            {
                Header: 'Activity',
                id: 'predecessor.activityName',
                accessor: (row) => `${row.predecessor.activityName} ${row.predecessor.activityId}`,
                Cell: ({ row }) => {
                    const { taskId, activityName } = row.original.predecessor;
                    return (
                        <div className={classes.overflow}>
                            <ActivityCell activityName={activityName} taskId={taskId} />
                        </div>
                    );
                },
            },
            {
                Header: 'Activity id',
                id: 'predecessor.activityId',
                accessor: (row) => `${row.predecessor.activityName} ${row.predecessor.activityId}`,
                Cell: ({ row }) => {
                    const { activityId } = row.original.predecessor;
                    return (
                        <div className={classes.overflow}>
                            <ActivityIdCell activityId={activityId} />
                        </div>
                    );
                },
            },

            {
                Header: 'Relation Type',
                accessor: 'relationType',
                width: 130,
                fixedSize: true,
                Cell: ({ value }) => <RelationTypeCell value={value} />,
            },
        ],
    },
    {
        Header: () => <div className={classes.header}>Successor</div>,
        meta: {
            columnLabel: 'Successor',
        },
        id: 'Successor',
        columns: [
            {
                Header: 'Version ID',
                accessor: 'successor.originalProjectId',
                width: 120,
                fixedSize: true,
            },
            {
                Header: 'Version Name',
                accessor: 'successor.originalProjectName',
                Cell: ({ value }) => {
                    return <TooltipCell value={value} />;
                },
            },
            {
                Header: 'Activity',
                id: 'successor.activityName',
                accessor: (row) => `${row.successor.activityName} ${row.successor.activityId}`,
                Cell: ({ row }) => {
                    const { taskId, activityName } = row.original.successor;
                    return (
                        <div className={classes.overflow}>
                            <ActivityCell activityName={activityName} taskId={taskId} />
                        </div>
                    );
                },
            },
            {
                Header: 'Activity id',
                id: 'successor.activityId',
                accessor: (row) => `${row.successor.activityName} ${row.successor.activityId}`,
                Cell: ({ row }) => {
                    const { activityId } = row.original.successor;
                    return (
                        <div className={classes.overflow}>
                            <ActivityIdCell activityId={activityId} />
                        </div>
                    );
                },
            },
        ],
    },
];
